<script>
export default {
	name: "SecondaryHero",
	components: {},
	props: {
		backgroundImageUrl: {
			type: String,
		},
		imgUrl: {
			type: String,
		},
	},
};
</script>

<template>
	<section
		class="pt-2"
		:style="{
			backgroundImage: `url(${backgroundImageUrl})`,
		}"
	>
		<div class="container">
			<div class="row justify-content-end">
				<div class="col-60 col-lg-40 pt-3 pt-lg-5">
					<img :src="imgUrl" alt="Solutions hero image" class="ms-auto" />
				</div>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>
@import "../../sass/abstracts/mixins";

section {
	height: 35rem;
	background-size: cover;

	@include media-breakpoint-down(md) {
		height: 20rem;
	}

	img {
		width: 100%;
	}
}
</style>
